import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import {apiList} from './coreApiList';
import {LOG_DOC_TYPE} from './const';
export class SourceAndApiError {

    key = 'SourceAndApiError';

    logger: PerformanceLogger;

    hasError = false;

    constructor(logger: PerformanceLogger) {
        // @todo 需要根据之前缓存住的错误 进行上报
        this.logger = logger;
        try {
            this.arrangeSourceErrorBefore();
        } catch (err) {
            console.log('err: ', err);
        }
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            const opVersion = logger?.getOpVersionInfo();
            logger.feLogger({
                id,
                data: {
                    ...data,
                    opVersion,
                },
            });
        }
    };

    arrangeSourceErrorBefore() {
        const WIKI_RESOURCE_ERROR = (window as any).WIKI_RESOURCE_ERROR;
        const resourceError = JSON.parse(localStorage.getItem(WIKI_RESOURCE_ERROR) || '[]');
        resourceError.forEach((resource: string) => {
            this.logSourceError(resource);
        });
        localStorage.removeItem(WIKI_RESOURCE_ERROR);
    }

    logSourceError(resource: string) {
        if (this.hasError) {
            return;
        }
        this.logWeb({
            id: '80001.2.20',
            data: {
                resource,
            },
        });
        this.hasError = true;
    }

    shouldApiErrorLogToWeb(url: string, errCode?: number) {
        const matchedApi = apiList.find(api => {
            // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
            return !!url.match(api.url);
        });
        if (!matchedApi) {
            return false;
        }
        if (!errCode) {
            return true;
        }
        const isCodeInWhiteList = matchedApi.returnCodeWhiteList.includes(`${errCode}`);
        return !isCodeInWhiteList;
    }

    logApiError(url: string, errCode?: number, errMsg?: string) {
        try {
            if (this.hasError) {
                return;
            }
            if (!this.shouldApiErrorLogToWeb(url, errCode)) {
                return;
            }
            this.logWeb({
                id: '80001.2.21',
                data: {
                    type: 'apiError',
                    url,
                    errCode,
                    errMsg: `${errMsg}`,
                },
            });
            this.hasError = true;
        } catch (err) {
            // console.log('err: ', err);

        }
    }

    logRteError(error?: Error | unknown) {
        if (this.hasError) {
            return;
        }
        this.logWeb({
            id: '80001.2.21',
            data: {
                type: 'rteError',
                error,
                docType: LOG_DOC_TYPE.doc,
            },
        });
        this.hasError = true;
    }

    logSheetError(error: Error | unknown, errorType: string) {
        if (this.hasError) {
            return;
        }
        this.logWeb({
            id: '80001.2.21',
            data: {
                type: 'sheetError',
                error,
                docType: LOG_DOC_TYPE.sheet,
                errorType,
            },
        });
        this.hasError = true;
    }

    logDataSheetError(error?: Error | unknown) {
        if (this.hasError) {
            return;
        }
        this.logWeb({
            id: '80001.2.21',
            data: {
                type: 'datasheetError',
                error,
                docType: LOG_DOC_TYPE.datasheet,
            },
        });
        this.hasError = true;
    }
}
